/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ALERT_TYPE_INFO, Alert } from '@squiz/sds';
import { EntityDxpUserMe } from 'apps/console-core/src/Services/console';
import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MONITORING_STRINGS } from '../../../../Constants/Strings.constants';

/**
 * User information alert.
 */
export const UserInfoAlert = (): JSX.Element => {
  const { t } = useTranslation();
  const { consoleUser }: { consoleUser: EntityDxpUserMe | null } = useConsoleServiceStore();
  const referenceId = consoleUser?.referenceId || ``;

  // Labels
  const labels = useMemo(() => {
    return {
      userLogIdMessage: t(MONITORING_STRINGS.userLogId),
    };
  }, [t]);

  if (!referenceId) {
    return <></>;
  }

  const userLogIdMessage = (
    <div>
      <span>{labels.userLogIdMessage}</span> <strong>{referenceId}</strong>
    </div>
  );

  return (
    <div className="logging-help">
      <Alert message={userLogIdMessage} type={ALERT_TYPE_INFO} />
    </div>
  );
};
